import {useLocation} from 'react-router-dom';
import {Grid, Stack} from '@mantine/core';
import {
    TabbedComponent,
    TabComponentTab,
} from '@flexinet/ui-components';

import {CustomerSubscription} from '../types';
import {InformationPropertyCard} from './InformationPropertyCard.tsx';
import {MetadataPropertyCard} from './MetadataPropertyCard.tsx';
import {IndexPage as SubscriptionItemsPage} from '../../subscription-items/pages/IndexPage.tsx';
import {IndexPage as InvoicesPage} from '../../invoices/pages/IndexPage.tsx';

const getActiveTabFromHash = (hash: string): string | null => {
    const match = hash.match(/^#tab=(.+)$/);
    return match ? decodeURIComponent(match[1]) : null;
};

// Renders the record it is given. It used to copy it into useState on mount, so after an
// Edit the refetched record never reached the cards and the page kept the old values.
export const Profile = ({record}: { record: CustomerSubscription }) => {
    const location = useLocation();
    const activeTab = getActiveTabFromHash(location.hash);

    const tabDefinitions: { title: string, component: JSX.Element }[] = [
        {
            title: 'Items',
            component: <SubscriptionItemsPage subscriptionId={record.id}/>,
        },
        {
            title: 'Invoices',
            component: <InvoicesPage subscriptionId={record.id}/>,
        },
    ];

    const tabs = tabDefinitions.map(tab => ({
        ...tab,
        active: activeTab ? tab.title === activeTab : undefined,
    })) as TabComponentTab[];

    return (
        <Grid>
            <Grid.Col span={{base: 12, lg: 4}}>
                <Stack gap={'xl'}>
                    <InformationPropertyCard record={record}/>
                    <MetadataPropertyCard record={record}/>
                </Stack>
            </Grid.Col>
            <Grid.Col span={{base: 12, lg: 8}}>
                <TabbedComponent key={activeTab ?? 'default'} tabs={tabs}/>
            </Grid.Col>
        </Grid>
    );
};
